import styled from 'styled-components'
import { Link } from "react-router-dom";

export const CataloguesWrapper = styled.section`
  padding: 0 0;
  display: flex;
  flex-direction: column;
  background: linear-gradient(
    ${({ theme }) => theme.colors.defaultGrey},
    ${({ theme }) => theme.colors.primaryColor}
  );
  background-size: cover;
  background-position: center;
  > div {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 0 auto;
    align-items: center;
    }
  }
  h1 {
    text-align: center;
    font-size: 3rem;
    color: ${({ theme }) => theme.colors.textPrimary};
    font-weight: 100;
    margin: -0.1% 0 0;
    padding: 1rem 0;
    background: ${({ theme }) => theme.colors.overlayColor};
  }
  > p {
    text-align: center;
    letter-spacing: 1px;
    font-size: 1.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 2rem;
    margin: -0.1% auto 1rem;
    width: 100vw;
    background: ${({ theme }) => theme.colors.overlayColor};
    span {
      margin: 0 auto;
      max-width: 50%;
    }
  }
`;
export const StyledCatalogueBox = styled.article`
  width: 80vw;
  max-width: 280px;
  display: grid;
  grid-template-columns: 1fr;
  background: linear-gradient(
      ${({ theme }) => theme.colors.defaultOverlay},
      ${({ theme }) => theme.colors.defaultOverlay}
    ),
    url(${(props) => props.bgImage});
  background-size: cover;
  background-position: center;
  padding: 5rem 2rem;
  border-radius: 40% 0 40% 0;
  box-shadow: ${(props) =>
    props.inFocus
      ? "inset 500px 100px 100px rgba(255, 255, 255, 0.2)"
      : "2px 2px 4px rgba(0,0,0, 0.15)"};
  h3 {
    opacity: ${(props) => (props.inFocus ? 0 : 1)};
    visibility: ${(props) => (props.inFocus ? "hidden" : "visible")};
    grid-area: 1/1/-1/-1;
    font-size: 2.5rem;
    font-weight: 300;
    text-align: center;
    justify-self: center;
    align-self: center;
    transition: all 0.3s ease;
  }
  div {
    opacity: ${(props) => (props.inFocus ? 1 : 0)};
    visibility: ${(props) => (props.inFocus ? "visible" : "hidden")};
    grid-area: 1/1/-1/-1;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.2s ease;
    > p {
      text-align: center;
      letter-spacing: 1.5px;
    }
    button {
      background-color: ${({ theme }) => theme.colors.solidDark};
      color: inherit;
      font-size: 1.4rem;
      padding: 1rem 2rem;
      margin: 5% auto 0;
      border-radius: 50px;
      border: none;
      :hover {
        filter: brightness(150%);
        transform: scale(1.02);
        transition: all 0.2s ease;
      }
      :focus {
        outline: none;
        border: 1px dotted ${({ theme }) => theme.colors.textPrimary};
      }
    }
  }
`;
export const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  font-family: inherit;
  font-size: unset;
  display: block;
  border-radius: 40% 0 40% 0;
  margin: 2rem 1.5rem;
  outline: none;
  border: 2px dotted transparent;
  transition: all 0.2s linear;
  :hover {
    border: 2px dotted ${({ theme }) => theme.colors.solidDark};
  }
  :focus,
  :focus-visible {
    outline: none;
    border: 2px dotted ${({ theme }) => theme.colors.solidDark};
  }
`;
